// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"52e9fdc8","198":"629506b5","255":"d2d5aa7e","404":"2fd1372e"}[chunkId] + ".chunk.js";
};